import * as React from "react"
import { FormattedMessage } from "react-intl"
import LanguageSwitcher from "../languageSwitcher/languageSwitcher"
import LanguageSwitcherRedux from "../../redux/languageSwitcher/languageSwitcherRedux"
import CartRedux from "../../redux/sagaCart/sagaCartRedux"
import { connect } from "react-redux"
import NavItem from "./navItem"
import $ from "jquery"
import { Link, Redirect } from "react-router-dom"
import "./navigation.css"
import { checkIsMobileDevice } from "../../helpers/utility"
import AccountModal from "../accountModal/accountModal"
import UserInfoModal from "../accountModal/userInfoModal"
import SagaAuthRedux from "../../redux/sagaAuth/sagaAuthRedux"
import { IUserProfileResponse } from "../../redux/sagaAuth/ISagaAuth"
import "./index.css"
import {
  Collapse,
  Navbar,
  Nav,
  NavItem as NavItem2,
  NavLink,
  Container
} from "reactstrap"
import imgFacebook from "../../images/hiso-bus-rental-menu/hiso-bus-rental-menu-facebook.svg"
import imgLine from "../../images/hiso-bus-rental-menu/hiso-bus-rental-menu-line.svg"
import imgCall from "../../images/hiso-bus-rental-menu/hiso-bus-rental-menu-phone-2.svg"
import CartModal from "../../components/cart/cartModal"
import { IPriceCompareDetail } from "../../redux/sagaBooking/IBooking"
import { isIOS13 } from "react-device-detect"
import { slide as Menu } from "react-burger-menu"

const myStyle = {
  menuRadius: {
    borderTop: "1px solid white"
  },

  imgRadius: {
    marginRight: 10,
    height: 25
  },

  menuLink: {
    // paddingBottom:10,
    color: "#ff965e",
    cursor: "pointer",
    textDecoration: "none"
  },

  imgActive: {
    border: " 2px solid #1a75ff"
  },

  menuLinkIcon: {
    padding: ".5rem 1rem",
    color: "#ffffff"
  }
}

class Navigation extends React.Component<
  {
    userProfileResponse: IUserProfileResponse
    updateUserProfileResponse: any
    accountVisible: boolean
    language: any
    locale: any
    navHieght: number
    changeLanguage: (language: string) => void
    requestLogout?: () => void
    requestEnableLoginModal: (isLogin: boolean) => void
    requestOpenCart: (cartVisible: boolean) => void
    requestAddCarToCart: (cars: IPriceCompareDetail[], routes: any[]) => void
    pathName: string
    cartVisible: boolean
    cars: any[]
    routes: any[]
    search: string
  },
  {
    accountModalVisible: boolean
    accountModalActiveTab: string
    userProfileResponse: any
    language: any
    collapsed: boolean
    collapsedProfile: boolean
    currentMemu: string
    isMenuOpen: boolean
    isRedirect: boolean
  }
> {
  constructor(props) {
    super(props)
    this.state = {
      accountModalVisible: false,
      accountModalActiveTab: "tab-signin",
      userProfileResponse: this.props.userProfileResponse,
      collapsed: false,
      language: this.props.language.language,
      collapsedProfile: false,
      currentMemu: "home",
      isMenuOpen: false,
      isRedirect: false
    }
  }

  public onCloseAccountModal() {
    this.setState({ accountModalVisible: false })
    this.props.requestEnableLoginModal(false)
  }

  public componentDidUpdate(prevprops) {
    // Check whether path is changed: true hide menu
    if ("pathName" in prevprops && "pathName" in this.props) {
      if (prevprops.pathName !== this.props.pathName) {
        this.setState({ isMenuOpen: false })
        if (location.pathname.startsWith("/th/blog")) {
          this.props.changeLanguage("th")
        }
      }
    }

    const displayMessenger = ["bookingInfo", "bookingPayment"]
    for (const element of displayMessenger) {
      if (this.props.pathName.includes(element)) {
        document.getElementById("fb-root").style.display = "none"
        break
      } else {
        document.getElementById("fb-root").style.display = "block"
      }
    }
  }

  public componentDidMount() {
    this.onScroll()
    this.setState({ collapsed: false, collapsedProfile: false })
  }

  public componentWillReceiveProps(newProps) {
    const newState: any = {}
    newState.userProfileResponse = newProps.userProfileResponse
    if (newState.userProfileResponse) {
      newState.accountModalVisible = false
    }
    this.setState(newState)
  }

  public onScroll() {
    // if access website by desktop, Use css for changed color when scrolled
    if (true) {
      $(document).scroll(function() {
        const $mainNav = $("#second-nav")
        $mainNav.toggleClass(
          "scrolled",
          $(this).scrollTop() > $mainNav.height() + $("#first-nav").height()
        )
      })
    }
  }

  public onToggleCartModal() {
    const { cartVisible, requestOpenCart } = this.props
    requestOpenCart(!cartVisible)
    if (this.state.isMenuOpen) {
      this.setState({
        isMenuOpen: false
      })
    }
  }

  public onCloseCartModal() {
    const { requestOpenCart } = this.props
    requestOpenCart(false)
  }

  public renderNotSigninMenu() {
    const { cars } = this.props
    return (
      <div style={{ display: "inline-flex" }}>
        <li
          className="nav-item vertical-middle mr-1 border-right"
          style={{ paddingTop: 5 }}
        >
          <a
            className="nav-link round-button"
            onClick={() => this.onToggleCartModal()}
          >
            <span className="text-blue">
              <img
                src={`/images/bus/hiso-bus-rental-bus.svg`}
                height="20px"
                alt="hiso-bus-rental-traffic"
              />
            </span>
            <span
              className="badge badge-light"
              style={{ position: "relative", top: -35, left: 15 }}
            >
              {cars && cars.length}
            </span>
          </a>
        </li>
        <li className="pl-3 nav-item vertical-middle  border-right">
          <button
            className="btn btn-danger my-2 my-sm-0"
            style={{ minWidth: 100, borderRadius: 7 }}
            onClick={() =>
              this.setState({
                accountModalVisible: true,
                accountModalActiveTab: "tab-signin"
              })
            }
          >
            <FormattedMessage id="Signin" />
          </button>
        </li>
        <li className="nav-item vertical-middle">
          <button
            className="btn btn-outline-dark  my-2 my-sm-0"
            style={{ minWidth: 100, borderRadius: 7 }}
            type="submit"
            onClick={() =>
              this.setState({
                accountModalVisible: true,
                accountModalActiveTab: "tab-register"
              })
            }
          >
            <FormattedMessage id="Register" />
          </button>
        </li>
        <AccountModal
          visible={
            this.props.accountVisible
              ? this.props.accountVisible
              : this.state.accountModalVisible
          }
          onClose={() => this.onCloseAccountModal()}
          activeTab={this.state.accountModalActiveTab}
        />
      </div>
    )
  }

  public renderSignedinMenu() {
    const { cars } = this.props
    return (
      <div style={{ display: "inline-flex" }}>
        <li className="nav-item vertical-middle mr-1" style={{ paddingTop: 5 }}>
          <a
            className="nav-link round-button"
            onClick={() => this.onToggleCartModal()}
          >
            <span className="text-blue">
              <img
                src={`/images/bus/hiso-bus-rental-bus.svg`}
                height="20px"
                alt="hiso-bus-rental-traffic"
              />
            </span>
            <span
              className="badge badge-light"
              style={{ position: "relative", top: -35, left: 15 }}
            >
              {cars && cars.length}
            </span>
          </a>
        </li>
        <li className="nav-item dropdown">
          <a
            className="nav-link dropdown-toggle hiso-bus-rental-userinfo"
            href="#"
            id="navbarDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <img
              className="avatar"
              src={
                this.state.userProfileResponse &&
                this.state.userProfileResponse.picture
                  ? `data:image/png;base64,${this.state.userProfileResponse.picture}`
                  : require("../../images/hiso-bus-rental-blank-profile-picture.png")
              }
              alt="hiso-bus-rental-avatar"
            />
          </a>
          <div className="dropdown-menu" aria-labelledby="navbarDropdown">
            <Link
              className="navbar-brand"
              to={`/${this.props.locale}/mybooking`}
            >
              <span
                style={{ fontSize: "1rem" }}
                className="dropdown-item anchor-span"
              >
                {<FormattedMessage id="MyBooking" />}
              </span>
            </Link>
            <Link
              className="navbar-brand"
              to={`/${this.props.locale}/userinfo`}
            >
              <span
                style={{ fontSize: "1rem" }}
                className="dropdown-item anchor-span"
              >
                {<FormattedMessage id="UserInfo" />}
                <br /> {this.state.userProfileResponse.firstName.toLowerCase()}
              </span>
            </Link>
            <div className="dropdown-divider" />
            <Link className="" to={`/${this.props.locale}/`}>
              <span
                className="dropdown-item anchor-span"
                onClick={() => this.props.requestLogout()}
              >
                <FormattedMessage id="Signout" />
              </span>
            </Link>
          </div>
        </li>
      </div>
    )
  }

  public toggleNavbar = () => {
    this.setState({
      collapsed: !this.state.collapsed,
      collapsedProfile: false
    })
  }

  public toggleNavbarProfile = () => {
    this.setState({
      collapsed: false,
      collapsedProfile: !this.state.collapsedProfile
    })
  }

  public handleClickChangeLanguage = () => {}

  public handleClickimg = lang => {
    this.setState({ language: lang })
    this.props.changeLanguage(lang)
  }

  public handleMenuOpenChange = state => {
    this.setState({ isMenuOpen: state.isOpen })
  }

  public setStateAsync = async newState => {
    return new Promise(resolve => {
      this.setState(newState, () => resolve())
    })
  }

  public handleLogout = async () => {
    console.log("path name", window.location.pathname)
    if (
      window.location.pathname === "/th/userinfo" ||
      window.location.pathname === "/en/userinfo"
    ) {
      console.log("in")
      // this.setState({isRedirect: true})
      await this.setStateAsync({ isRedirect: true })
      // this.props.requestLogout()
      // return;
    }
    console.log("out")
    this.props.requestLogout()
  }

  public renderImg = () => {
    return (
      <div className="logo-nav">
        <Link
          className="navbar-brand"
          style={{ margin: 0 }}
          to={`/${this.props.locale}`}
        >
          <img
            onClick={() =>
              this.setState({
                collapsed: false,
                collapsedProfile: false
              })
            }
            className="hisobus-rental-brand"
            src={require("../../images/hiso-bus-rental-logo-ไฮโซบัสขรถบัสเช่า-โลโก้-ฟ้าส้ม-ข้อความ.jpg")}
            alt="hiso-bus-rental-logo-วีคาโบ้ขรถบัสเช่า-โลโก้-ฟ้าส้ม-ข้อความ"
          />
        </Link>
        {/* this is for drop down and modal */}
        <Collapse isOpen={this.state.collapsedProfile} navbar>
          <Nav style={{ backgroundColor: "#183050" }} navbar>
            {!this.state.userProfileResponse ? (
              <div>
                <NavItem2>
                  <NavLink
                    style={myStyle.menuLink}
                    onClick={() =>
                      this.setState({
                        accountModalVisible: true,
                        accountModalActiveTab: "tab-signin"
                      })
                    }
                  >
                    <FormattedMessage id="Signin" />
                  </NavLink>
                </NavItem2>
                <NavItem2 style={myStyle.menuRadius}>
                  <NavLink
                    style={myStyle.menuLink}
                    onClick={() =>
                      this.setState({
                        accountModalVisible: true,
                        accountModalActiveTab: "tab-register"
                      })
                    }
                  >
                    <FormattedMessage id="Register" />
                  </NavLink>
                </NavItem2>
              </div>
            ) : (
              <div>
                <NavItem2>
                  <NavLink
                    style={myStyle.menuLink}
                    tag={Link}
                    onClick={() => {
                      this.setState({ collapsedProfile: false })
                    }}
                    to={`/${this.props.locale}/mybooking`}
                  >
                    <FormattedMessage id="MyBooking" />
                  </NavLink>
                </NavItem2>
                <NavItem2>
                  <NavLink
                    style={myStyle.menuLink}
                    tag={Link}
                    onClick={() => {
                      this.setState({ collapsedProfile: false })
                    }}
                    to={`/${this.props.locale}/userinfo`}
                  >
                    <FormattedMessage id="UserInfo" />
                  </NavLink>
                </NavItem2>
                <NavItem2 style={myStyle.menuRadius}>
                  <NavLink
                    style={myStyle.menuLink}
                    onClick={() => {
                      this.props.requestLogout()
                    }}
                  >
                    ( {this.props.userProfileResponse.firstName.toLowerCase()} ){" "}
                    <FormattedMessage id="Signout" />
                  </NavLink>
                </NavItem2>
              </div>
            )}
          </Nav>
        </Collapse>
      </div>
    )
  }

  public renderAccount = () => {
    return (
      <div className="account-nav">
        <button
          onClick={this.toggleNavbarProfile}
          className="navbar-toggler"
          type="button"
        >
          {!this.props.userProfileResponse ? (
            <span className="hisobus-rental-user-icon" />
          ) : (
            <img
              className="avatar"
              src={
                this.state.userProfileResponse &&
                this.state.userProfileResponse.picture
                  ? `data:image/png;base64,${this.state.userProfileResponse.picture}`
                  : require("../../images/hiso-bus-rental-blank-profile-picture.png")
              }
              alt="hiso-bus-rental-blank-profile-picture"
            />
          )}
        </button>
      </div>
    )
  }

  public renderSideNavNotSignin = () => {
    return (
      <div>
        <NavLink
          style={myStyle.menuLink}
          onClick={() =>
            this.setState({
              isMenuOpen: false,
              accountModalVisible: true,
              accountModalActiveTab: "tab-signin"
            })
          }
        >
          <FormattedMessage id="Signin" />
        </NavLink>
        <NavLink
          style={myStyle.menuLink}
          onClick={() =>
            this.setState({
              isMenuOpen: false,
              accountModalVisible: true,
              accountModalActiveTab: "tab-register"
            })
          }
        >
          <FormattedMessage id="Register" />
        </NavLink>
      </div>
    )
  }
  public renderSideNavSigninTop = () => {
    return (
      <div>
        <NavLink
          style={{ color: "white" }}
          tag={Link}
          onClick={() => {
            this.setState({ collapsedProfile: false })
          }}
          to={`/${this.props.locale}/mybooking`}
        >
          <FormattedMessage id="MyBooking" />
        </NavLink>
        <NavLink
          style={{ color: "white" }}
          tag={Link}
          onClick={() => {
            this.setState({ collapsedProfile: false })
          }}
          to={`/${this.props.locale}/userinfo`}
        >
          <FormattedMessage id="UserInfo" />
        </NavLink>
        <hr />
      </div>
    )
  }

  public renderSideNavSigninBottom = () => {
    return (
      <div>
        <Link
          style={myStyle.menuLink}
          onClick={() => this.handleLogout()}
          to={`/${this.props.locale}/`}
        >
          ( {this.props.userProfileResponse.firstName.toLowerCase()} ){" "}
          <FormattedMessage id="Signout" />
        </Link>
      </div>
    )
  }

  public render() {
    const { language, isRedirect } = this.state
    const {
      navHieght,
      userProfileResponse,
      cartVisible,
      cars,
      routes,
      search
    } = this.props
    if (isRedirect) {
      this.setState({ isRedirect: false })
      return <Redirect to={`/`} />
    }
    return (
      <React.Fragment>
        {/* For Desktop */}
        <div className="hide-tablet">
          <nav
            className="navbar navbar-expand-lg navbar-dark fixed-top pl-lg-5 pr-lg-5 "
            id="first-nav"
          >
            <Container style={{ justifyContent: "flex-end" }}>
              <div
                className="header"
                style={{ display: "flex", alignItems: "center" }}
              >
                <div className="facebook-container">
                  <a
                    href="https://www.facebook.com/vecabotrans"
                    target="_blank"
                  >
                    <img
                      style={myStyle.imgRadius}
                      src={imgFacebook}
                      alt="hiso-bus-rental-icon-facebook"
                    />
                    <span className="pr-4">
                      Vecabo บริการเช่ารถบัสและรถตู้ออนไลน์
                    </span>
                  </a>
                </div>
                <div className="line-container">
                  <a href="https://line.me/ti/p/~@vecabo">
                    <img
                      style={myStyle.imgRadius}
                      src={imgLine}
                      alt="hiso-bus-rental-icon-line"
                    />
                    <span className="pr-4">
                      @vecabo (<FormattedMessage id="withat" />)
                    </span>
                  </a>
                </div>
                <div className="tel-container">
                  <a href="tel:02-0803972" target="_blank">
                    <img
                      style={myStyle.imgRadius}
                      src={imgCall}
                      alt="hiso-bus-rental-icon-call"
                    />
                    <span>02-0803972</span>
                  </a>
                </div>
                <LanguageSwitcher />
              </div>
            </Container>
          </nav>
          <nav
            className="navbar navbar-expand-lg fixed-top pl-lg-5 pr-lg-5 hiso-bus-rental-shadow"
            id="second-nav"
          >
            <Container className="">
              <Link className="navbar-brand" to={`/${this.props.locale}`}>
                <img
                  src={require("../../images/hiso-bus-rental-logo-ไฮโซบัสขรถบัสเช่า-โลโก้-ฟ้าส้ม-ข้อความ.jpg")}
                  width="auto"
                  height="45"
                  className="d-inline-block align-top"
                  alt="hiso-bus-rental-logo-วีคาโบ้ขรถบัสเช่า-โลโก้-ฟ้าส้ม-ข้อความ"
                />
              </Link>
              <ul className="navbar-nav">
                <NavItem
                  name="VehicleManagement"
                  path={`/${this.props.locale}/tool`}
                />
                <NavItem
                  name="AboutUs"
                  path={`/${this.props.locale}/aboutus`}
                />
                <NavItem name="Blog" path={`/${this.props.locale}/blog`} />
                <NavItem
                  name="ContactUs"
                  path={`/${this.props.locale}/contactus`}
                />
                <NavItem name="Faq" path={`/${this.props.locale}/faq`} />
                {/* <NavItem
                  name="Customer"
                  path={`/${this.props.locale}/customer`}
                /> */}
                {!this.state.userProfileResponse ? null : (
                  <NavItem
                    name="MyBooking"
                    path={`/${this.props.locale}/mybooking`}
                  />
                )}
              </ul>
              <ul className="navbar-nav ml-auto second-nav-right">
                {!this.state.userProfileResponse
                  ? this.renderNotSigninMenu()
                  : this.renderSignedinMenu()}
              </ul>
            </Container>
          </nav>
        </div>

        {/* For Tablet and Mobile */}
        <div
          className="sidebar-nav hide-desktop"
          style={{ height: navHieght, zIndex: 1 }}
        >
          <Menu
            width={"70%"}
            disableAutoFocus
            isOpen={this.state.isMenuOpen}
            onStateChange={state => this.handleMenuOpenChange(state)}
          >
            {this.state.userProfileResponse
              ? this.renderSideNavSigninTop()
              : null}
            {/* General Menu */}
            <NavItem name="Home" path={`/${this.props.locale}`} />
            <NavItem
              name="VehicleManagement"
              path={`/${this.props.locale}/tool`}
            />
            <NavItem name="AboutUs" path={`/${this.props.locale}/aboutus`} />
            <NavItem name="Blog" path={`/${this.props.locale}/blog`} />
            <NavItem
              name="ContactUs"
              path={`/${this.props.locale}/contactus`}
            />
            <NavItem name="Faq" path={`/${this.props.locale}/faq`} />
            {/* <NavItem name="Customer" path={`/${this.props.locale}/customer`} /> */}
            <Link
              style={myStyle.menuLinkIcon}
              onClick={() => this.onToggleCartModal()}
              to={`/${this.props.locale}/`}
            >
              <img
                style={{ marginRight: "10px" }}
                src="/images/bus/hiso-bus-rental-bus.svg"
                height="20px"
                alt="hiso-bus-rental-traffic"
              />
              <FormattedMessage id="MyVehicles" />
            </Link>
            {/* Vecabo Contact
            <hr />
            <div>
                <a href="https://www.facebook.com/vecabotrans" target="_blank">
                  <img
                    style={myStyle.imgRadius}
                    src={imgFacebook}
                    alt="hiso-bus-rental-icon-facebook"
                  />
                </a>
                <a href="https://line.me/ti/p/~@vecabo" target="_blank">
                  <img
                    style={myStyle.imgRadius}
                    src={imgLine}
                    alt="hiso-bus-rental-icon-line"
                  />
                </a>
                <a href="tel:02-0803972" target="_blank">
                  <img
                    style={myStyle.imgRadius}
                    src={imgCall}
                    alt="hiso-bus-rental-icon-call"
                  />
                </a>
              </div>
               */}

            {/* Sign in / Sign up */}
            <hr />
            {!this.state.userProfileResponse
              ? this.renderSideNavNotSignin()
              : this.renderSideNavSigninBottom()}

            {/* Language */}
            <hr />
            <div style={{ bottom: "30px" }}>
              <NavLink
                style={myStyle.menuLink}
                onClick={() => {
                  this.handleClickChangeLanguage()
                }}
              >
                {language === "en" ? (
                  <div>
                    <img
                      className="lang-img-active"
                      src={require(`../../images/flags/en.png`)}
                      onClick={() => {
                        this.handleClickimg("en")
                      }}
                      alt="hiso-bus-rental-flags-en"
                    />

                    <img
                      className="lang-img"
                      src={require(`../../images/flags/th.png`)}
                      onClick={() => {
                        this.handleClickimg("th")
                      }}
                      alt="hiso-bus-rental-flags-th"
                    />
                  </div>
                ) : (
                  <div>
                    <img
                      className="lang-img"
                      style={{ marginRight: 10 }}
                      src={require(`../../images/flags/en.png`)}
                      onClick={() => {
                        this.handleClickimg("en")
                      }}
                      alt="hiso-bus-rental-flags-en"
                    />

                    <img
                      className="lang-img-active"
                      src={require(`../../images/flags/th.png`)}
                      onClick={() => {
                        this.handleClickimg("th")
                      }}
                      alt="hiso-bus-rental-flags-th"
                    />
                  </div>
                )}
              </NavLink>
            </div>
          </Menu>

          {this.renderImg()}
        </div>

        {/*  */}
        <UserInfoModal
          visible={
            !(userProfileResponse == null
              ? true
              : userProfileResponse.mobilePhone)
          }
          onClose={() => null}
          userInfo={userProfileResponse}
        />
        <CartModal
          visible={cartVisible}
          onClose={() => this.onCloseCartModal()}
          cars={cars}
          routes={routes}
          language={language}
          onToggle={() => this.onToggleCartModal()}
          onRemoveCar={(cars, routes) =>
            this.props.requestAddCarToCart(cars, routes)
          }
          search={search}
        />
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    userProfileResponse: state.SagaAuth.userProfileResponse,
    updateUserProfileResponse: state.SagaAuth.updateUserProfileResponse,
    data: state.SagaAuth.data,
    accountVisible: state.SagaAuth.accountVisible,
    language: state.Language,
    pathName: state.router.location.pathname,
    cartVisible: state.SagaCart.cartVisible,
    cars: state.SagaCart.cars,
    routes: state.SagaCart.routes,
    search: state.SagaCart.bookingQueryString
  }
}

const mapDispatchToProps = dispatch => {
  return {
    requestLogout: () => dispatch(SagaAuthRedux.requestLogout()),
    requestEnableLoginModal: (isLogin: boolean) =>
      dispatch(SagaAuthRedux.requestEnableLoginModal(isLogin)),
    changeLanguage: language =>
      dispatch(LanguageSwitcherRedux.changeLanguage(language)),
    requestOpenCart: (cartVisible: boolean) =>
      dispatch(CartRedux.requestOpenCart(cartVisible)),
    requestAddCarToCart: (cars: IPriceCompareDetail[], routes: any[]) =>
      dispatch(CartRedux.requestAddCarToCart(cars, routes))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Navigation)



// WEBPACK FOOTER //
// ./src/components/navigation/navigation.tsx